import { useSearchParams } from 'react-router-dom'

const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const getQueryParam = (name) => {
    return searchParams.get(name)
  }

  const setQueryParam = (name, value) => {
    setSearchParams((params) => {
      params.set(name, value)
      return params
    })
  }

  const deleteQueryParams = (names) => {
    setSearchParams((params) => {
      names.forEach((name) => {
        params.delete(name)
      })
      return params
    })
  }

  const resetAndSetQueryParams = (name, value) => {
    setSearchParams(() => {
      const newParams = new URLSearchParams()
      newParams.set(name, value)
      return newParams
    })
  }

  const initialParams = Object.fromEntries(searchParams)

  return {
    queryParams: initialParams,
    getQueryParam,
    setQueryParam,
    deleteQueryParams,
    resetAndSetQueryParams,
  }
}

export default useQueryParams
